import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchDocumentStatusComboSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getAllDocumentStatus from '../../services/document/getAllDocumentStatus'

export function * fetchDocumentStatus () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const documentStatusList = yield call(getAllDocumentStatus, auth.token)
    yield put(fetchDocumentStatusComboSuccess(documentStatusList))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchDocumentStatus () {
  yield takeLatest(combosActionTypes.FETCH_DOCUMENT_STATUS, fetchDocumentStatus)
}
